import React, { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from '../../../../axios/index';

// context
import { UserContext } from '../../../Context/UserContextProvider';

// styles
import styles from "../../../Dashboard/Notes/NoteDetail/NoteDetail.module.css"
import Dstyles from "../UserMyNotes/UserMyNotes.module.css"
import btnStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css"
import inputStyles from "../../../Dashboard/Meeting/AddMeeting/AddMeeting.module.css"


// Re Useable Components
import HomeNavbar from '../../../Home/HomeNavbar/HomeNavbar';
import Footer from '../../../Home/Footer/Footer';
import UserSideDashboard from '../../UserSideDashboard/UserSideDashboard';
import ReminderModal from '../../../Dashboard/Notes/Reminder/ReminderModal';

export default function UserNoteDetail(props) {
    // const id = props.match.params.id;
    const { state } = useLocation();
    const { userToken } = useContext(UserContext);
    const history = useHistory()
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const [btnLoader, setBtnLoader] = useState(false)
    const [reminderData, setReminderData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [addNoteInfo, setAddNoteInfo] = useState()
    const [showModal, setShowModal] = useState(false)
    const [addedReminderData, setAddedReminderData] = useState({
        title: "",
        hourValue: "",
        dateValue: ""
    })

    useEffect(() => {
        const dataHandler = async () => {
            const getNoteData = await axios.get(
                `Note/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            const getApiData = await axios.get(
                `Reminder/2/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            setAddNoteInfo(getNoteData.data.data);
            setReminderData(getApiData.data.data)
            setIsLoading(false)
        }
        dataHandler()

    }, [state, userToken])
    return (
        <>
            <ReminderModal
                show={showModal}
                onHide={() => setShowModal(false)}
                addedReminderData={addedReminderData}
                setAddedReminderData={setAddedReminderData}
                id={state.id}
            />

            {isLoading ? (
                <div className={btnStyles.loader_container}>
                    <div className={btnStyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir='rtl'>
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar />
                            <div className="container py-3 px-0 mt-4">
                                <div className='w-100 d-flex justify-content-md-between justify-content-center align-items-start'>
                                    <UserSideDashboard notes />
                                    <div className={`d-flex flex-column align-items-center justify-content-start p-md-4 p-3 ${Dstyles.main_container}`}>
                                        <div className='w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2'>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <div className={`my-md-0 my-3 ${Dstyles.title}`}>
                                                    یادداشت‌ها
                                                </div>
                                            </div>

                                            <div onClick={() => setShowModal(true)} className={`d-flex align-items-center justify-content-center ms-3 ${styles.add_btn_container}`} style={reminderData?.isActive === true ? { color: "#21409a" } : { color: "#8D8D8D" }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={
                                                    reminderData?.isActive === true ? "#21409a" : "#8D8D8D"
                                                }
                                                    className="bi bi-alarm ms-2" viewBox="0 0 16 16">
                                                    <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                                    <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                                </svg>
                                                یادآور
                                            </div>
                                        </div>

                                        <div
                                            className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3"
                                            dir="rtl"
                                        >
                                            <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                                                <div className="d-flex align-items-start justify-content-center flex-column my-3 w-100">
                                                    <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                        عنوان یادداشت
                                                    </div>
                                                    <input
                                                        className={`w-100 ${inputStyles.input}`}
                                                        type="text"
                                                        name="title"
                                                        value={addNoteInfo?.title}
                                                        onChange={changeHandler}
                                                    />
                                                </div>
                                                <div className='w-100 d-flex flex-column justify-content-center align-items-start my-4'>
                                                    <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                        متن یادداشت
                                                    </div>
                                                    <textarea
                                                        type="text"
                                                        name="description"
                                                        value={addNoteInfo?.description}
                                                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                                                        onChange={changeHandler}
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="w-100 d-flex justify-content-end flex-wrap align-items-center my-3"
                                            dir="rtl"
                                        >
                                            <div className={`w-100 d-flex align-items-center justify-content-around flex-wrap py-md-0 py-2 ${styles.date_detail_container}`}>
                                                <div className='d-flex align-items-center m-md-0 my-2'>
                                                    <div className={`d-flex align-items-center justify-content-center ms-2 ${styles.icon_container}`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill={
                                                            reminderData?.isActive === true ? "#21409a" : "#8D8D8D"
                                                        } className=" bi bi-alarm"
                                                            viewBox="0 0 16 16">
                                                            <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                                            <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                                        </svg>
                                                    </div>
                                                    <div className={styles.date_detail_text}>
                                                        {reminderData?.title ? reminderData.title : "یادآور"}
                                                    </div>
                                                </div>

                                                <div className='d-flex align-items-center m-md-0 my-2'>
                                                    <div className="d-flex align-items-center justify-content-center ms-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-calendar" viewBox="0 0 16 16">
                                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                        </svg>
                                                        <p className={`m-0 ${styles.text_gray}`}>
                                                            تاریخ:
                                                        </p>
                                                    </div>
                                                    <div className={styles.date_detail_text}>
                                                        {reminderData?.reminderDate ?
                                                            e2p(reminderData?.reminderDate)
                                                            :
                                                            "یادآور تنظیم نشده است"
                                                        }
                                                    </div>
                                                </div>

                                                <div className='d-flex align-items-center m-md-0 my-2'>
                                                    <div className="d-flex align-items-center justify-content-center ms-2">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-clock" viewBox="0 0 16 16">
                                                            <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                                                        </svg>
                                                        <p className={`m-0 ${styles.text_gray}`}>
                                                            ساعت:
                                                        </p>
                                                    </div>
                                                    <div className={styles.date_detail_text}>
                                                        {reminderData?.reminderTime ?
                                                            e2p(reminderData?.reminderTime)
                                                            :
                                                            "یادآور تنظیم نشده است"
                                                        }
                                                    </div>
                                                </div>

                                                <div className={` ${styles.text_primary}`} onClick={reminderHandler}>
                                                    {
                                                        reminderData?.isActive === true ? "غیرفعال سازی" : "یادآور تنظیم نشده است"
                                                    }
                                                </div>

                                            </div>
                                        </div>

                                        <div
                                            className="w-100 d-flex justify-content-end flex-wrap align-items-center my-3"
                                            dir="rtl"
                                        >
                                            <div className='w-100 d-flex align-items-end justify-content-center flex-column'>
                                                {btnLoader ? (
                                                    <div className={btnStyles.btn_loader_container}>
                                                        <div className={btnStyles.btn_spinner}></div>
                                                    </div>
                                                )
                                                    : (
                                                        <button type="submit" className={`btn ${styles.submit_btn}`} onClick={editNoteHandler}>
                                                            ویرایش
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                )}
        </>
    )

    function changeHandler(event) {
        setAddNoteInfo((prev) => {
            return { ...prev, [event.target.name]: event.target.value };
        });
    };

    async function editNoteHandler() {
        setBtnLoader(true)
        var editData = new FormData();
        editData.append('id', state.id);
        editData.append('Title', addNoteInfo.title);
        editData.append('Description', addNoteInfo.description);

        const apiData = await axios.put(
            "Note",
            editData,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        history.push('/user-my-notes')
    }

    async function reminderHandler() {
        var data = {
            "reminderId": reminderData?.id
        };

        const postApiData = await axios.delete(
            "Reminder/DeleteReminder",
            {
                data: data,
                headers: {
                   authorization: "Bearer " + userToken 
                },
            }
        );
    }
}
